import { colors } from '../../colors';
var form = {
  bgColor: colors.white,
  labelColor: colors.pinkishRed,
  errorColor: colors.warningRed,
  borderColor: colors.black,
  linkColor: colors.pinkishRed,
  documentFormBgColor: colors.white,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default form;